import React from 'react';
import { Spin } from 'antd';
import styled from 'styled-components';

export const LoadingOverlay: React.FC<{ children: React.ReactNode, active?: boolean }> = ({ children, active = true }) => {
  return (
    <OverlayContainer>
      {children}
      {active && (
        <SpinnerWrapper>
          <Spin size="large" />
        </SpinnerWrapper>
      )}
    </OverlayContainer>
  );
};

const OverlayContainer = styled.div`
  position: relative;
  width: 100%;
`;

const SpinnerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 1000;
`;
